module.exports = __webpack_public_path__ + "img/book.9bbcd433.svg";